import { render, staticRenderFns } from "./IntroPage.vue?vue&type=template&id=239ffe6c&scoped=true&"
import script from "./IntroPage.vue?vue&type=script&lang=ts&"
export * from "./IntroPage.vue?vue&type=script&lang=ts&"
import style0 from "./IntroPage.vue?vue&type=style&index=0&id=239ffe6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ffe6c",
  null
  
)

export default component.exports